var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "FormGroup",
    {
      attrs: {
        "error-container": _vm.errorContainer,
        label: _vm.label,
        name: _vm.name,
        floating: _vm.floating,
      },
    },
    [
      _c(
        "div",
        {
          ref: "root",
          staticClass: "fm-country-select",
          class: { "fm-country-select--open": _vm.open },
        },
        [
          _c(
            "select",
            {
              ref: "native",
              staticClass: "fm-select__native",
              attrs: {
                name: _vm.name,
                disabled: _vm.disabled,
                tabindex: "-1",
                "aria-hidden": "true",
              },
            },
            [
              _c("option", { attrs: { value: "" } }),
              _vm._v(" "),
              _vm._l(_vm.Countries, function (cname, code) {
                return _c("option", { key: code, domProps: { value: code } }, [
                  _vm._v(_vm._s(cname)),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fm-select__trigger form-control",
              class: { "fm-select__trigger--empty": !_vm.hasValue },
              attrs: {
                tabindex: _vm.disabled ? -1 : 0,
                role: "combobox",
                "aria-expanded": _vm.open,
              },
              on: {
                click: function ($event) {
                  !_vm.disabled && _vm.toggle()
                },
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.preventDefault()
                    !_vm.disabled && _vm.toggle()
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    )
                      return null
                    $event.preventDefault()
                    !_vm.disabled && _vm.toggle()
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "escape",
                        undefined,
                        $event.key,
                        undefined
                      )
                    )
                      return null
                    return _vm.close.apply(null, arguments)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    )
                      return null
                    return _vm.close.apply(null, arguments)
                  },
                ],
              },
            },
            [
              _c("span", {
                staticClass: "fm-select__sel-icon",
                attrs: { "aria-hidden": "true" },
                domProps: { innerHTML: _vm._s(_vm.GLOBE_ICON) },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "fm-select__sel-text" }, [
                _vm._v(_vm._s(_vm.currentLabel)),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "fm-select__chevron",
                  class: { "fm-select__chevron--up": _vm.open },
                  attrs: {
                    width: "11",
                    height: "7",
                    viewBox: "0 0 11 7",
                    fill: "none",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M1 1l4.5 5 4.5-5",
                      stroke: "currentColor",
                      "stroke-width": "1.6",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fm-drop" } }, [
            _vm.open
              ? _c(
                  "div",
                  {
                    staticClass: "fm-country-select__menu",
                    style: _vm.menuStyle,
                    attrs: { role: "listbox" },
                  },
                  [
                    _c("div", { staticClass: "fm-country-search" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "fm-country-search__icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "15",
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.query,
                            expression: "query",
                          },
                        ],
                        ref: "searchInput",
                        staticClass: "fm-country-search__input",
                        attrs: {
                          type: "text",
                          placeholder: "Search countries…",
                          autocomplete: "off",
                        },
                        domProps: { value: _vm.query },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "escape",
                                undefined,
                                $event.key,
                                undefined
                              )
                            )
                              return null
                            $event.preventDefault()
                            return _vm.close.apply(null, arguments)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.query = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.query
                        ? _c(
                            "button",
                            {
                              staticClass: "fm-country-search__clear",
                              attrs: {
                                type: "button",
                                tabindex: "-1",
                                "aria-label": "Clear search",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.query = ""
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "13",
                                    height: "13",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { ref: "list", staticClass: "fm-country-select__list" },
                      [
                        _vm._l(_vm.filteredCountries, function ([code, cname]) {
                          return _c(
                            "div",
                            {
                              key: code,
                              staticClass: "fm-select__item",
                              class: {
                                "fm-select__item--active": _vm.isSelected(code),
                              },
                              attrs: {
                                role: "option",
                                "aria-selected": _vm.isSelected(code),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.pick(code)
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass: "fm-select__item-icon",
                                attrs: { "aria-hidden": "true" },
                                domProps: { innerHTML: _vm._s(_vm.GLOBE_ICON) },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "fm-select__item-label" },
                                [_vm._v(_vm._s(cname))]
                              ),
                              _vm._v(" "),
                              _vm.isSelected(code)
                                ? _c(
                                    "svg",
                                    {
                                      staticClass: "fm-select__item-check",
                                      attrs: {
                                        width: "13",
                                        height: "10",
                                        viewBox: "0 0 13 10",
                                        fill: "none",
                                        "aria-hidden": "true",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M1.5 5L5 8.5L11.5 1.5",
                                          stroke: "#FFB000",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        !_vm.filteredCountries.length
                          ? _c(
                              "div",
                              { staticClass: "fm-country-select__empty" },
                              [
                                _vm._v("\n            No countries match "),
                                _c("em", [
                                  _vm._v('"' + _vm._s(_vm.query) + '"'),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }